import axios from 'axios';
import { SOCIALURL } from '../index';

export const getSocialApi = (postData) => {
  return axios.post(SOCIALURL, JSON.stringify(postData));
};
